"use strict";

define('rs/models/study',['rs/models/abstract', 'rs/models/document', 'rs/models/assignment.builder', 'rs/helper', 'moment'], function (AbstractModel, DocumentModel, AssignmentBuilder, helper, moment) {
  var StudyModel = AbstractModel.extend({
    properties: ['activityDate', 'activityDateDisplay', 'approvalDate', 'assignments', 'assignmentMap', 'expirationDate', 'adminCheckinDate', 'id', 'label', 'organizations', 'sponsor', 'sponsors', 'status', 'title', 'updateUser', 'version'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setupProperties();
    },
    setupProperties: function setupProperties() {
      var assignments = this.getAssignments(),
        sponsors = this.getSponsors(),
        sponsorNames = [],
        len = sponsors ? sponsors.length : 0,
        i = 0;
      AssignmentBuilder.setupAssignments(assignments);
      for (i = 0; i < len; ++i) {
        sponsorNames.push(sponsors[i].name);
      }
      this.setSponsor(sponsorNames.join(', '));
      this.setAssignmentMap(AssignmentBuilder.createAssignmentMap(assignments));
    },
    setActivityDate: function setActivityDate(date) {
      this.setActivityDateDisplay(moment(date).format('MM/DD/YYYY LT'));
      return this._super.apply(this, arguments);
    },
    requestDeleteStudy: function requestDeleteStudy() {
      return this.constructor.requestDeleteStudy(this.getId());
    },
    requestUpdate: function requestUpdate(newData) {
      newData = newData || {};
      newData.id = this.getId();
      return this.constructor.requestUpdateStudy(this.getId(), newData).bind(this).tap(function (data) {
        this.applyProperties(_.pick(data, this.properties));
        this.setupProperties();
      });
    },
    refresh: function refresh() {
      var that = this;
      return this.constructor.requestStudy(this.getId()).then(function (data) {
        that.applyProperties(_.pick(data, that.properties));
        that.setupProperties();
      });
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#GET#form/study': function GETForm_study(studies) {
        return StudyModel.models(studies);
      },
      '#GET#form/study/summary': function GETForm_study_summary(studies) {
        return StudyModel.models(studies);
      },
      'form/userStudyList': function form_userStudyList(studies) {
        return StudyModel.models(studies);
      },
      'form/study/:id': function form_study_Id(study) {
        return StudyModel.model(study);
      },
      'form/study/summary/:id': function form_study_summary_Id(study) {
        return StudyModel.model(study);
      },
      '#POST#form/study': function POSTForm_study(study) {
        return StudyModel.model(study);
      }
    },
    requestAllStudies: function requestAllStudies(params) {
      return this.get('form/study/summary', params);
    },
    requestUserStudies: function requestUserStudies(params) {
      return this.get('form/userStudyList', params);
    },
    requestCreateStudy: function requestCreateStudy(data) {
      return this.post('form/study', data, {
        jsonBody: true
      });
    },
    requestUpdateStudy: function requestUpdateStudy(id, data) {
      return this.put('form/study/' + id, data, {
        jsonBody: true
      });
    },
    requestStudy: function requestStudy(id) {
      return this.get('form/study/summary/' + id);
    },
    requestDeleteStudy: function requestDeleteStudy(studyId) {
      return this.del('form/study/' + studyId);
    }
  });
  return StudyModel;
});

